import {
  LotterySchema,
  ParticipantsSchema,
  RetailUnitSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type GetParticipantsParams = Static<typeof GetParticipantsParamsSchema>;
export const GetParticipantsParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'GetParticipantsParamsSchema' }
);

export type GetParticipantsResponse = Static<typeof GetParticipantsResponseSchema>;
export const GetParticipantsResponseSchema = Type.Object(
  {
    participants: ParticipantsSchema,
  },
  { additionalProperties: false, $id: 'GetParticipantsResponseSchema' }
);
